import React from 'react';
import classNames from 'classnames';

import { Props } from './DefaultItem';
import { DEFAULT_AFIBEL_SEPARATOR_CHARACTER } from 'services/product';
import { arrayChunk } from 'services/utils';
import { ENV_MEDIAS_URL_PRODUCT_SHEET } from 'settings/env';

import styles from '../ProductDescription.module.scss';

function CarePictogramsItem({ attrCode, content }: Props): JSX.Element {
  const baseUrl = `${ENV_MEDIAS_URL_PRODUCT_SHEET}/pictos_entretien/%pictogram_path%`;
  const lines = arrayChunk<string>(
    content.split(DEFAULT_AFIBEL_SEPARATOR_CHARACTER),
    2
  );

  return (
    <div className={classNames(styles[attrCode], styles.attrLines)}>
      {lines.map(([image, text], index) => (
        <p key={index} className={styles.content}>
          {image && (
            <img src={baseUrl.replace('%pictogram_path%', image)} alt={text} />
          )}
          {text && <span>{text}</span>}
        </p>
      ))}
    </div>
  );
}

export default CarePictogramsItem;
